<template>
  <form @submit.prevent="onSubmit" class="base-form">
    <slot></slot>
    <div class="form-actions d-flex justify-content-end">
      <button 
        type="submit" 
        :class="['btn', isSubmitting ? 'btn-success' : 'btn-primary', 'small-btn', 'me-2']" 
        :disabled="!isFormValid || isSubmitting"
      >
        <i :class="isSubmitting ? 'bi bi-hourglass-split me-1' : 'bi bi-save me-1'"></i>
        {{ isSubmitting ? 'Salvando…' : submitText }}
      </button>

      <button 
        type="button" 
        class="btn btn-secondary small-btn" 
        @click="onCancel"
      >
        <i class="bi bi-x-circle me-1"></i> {{ cancelText }}
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    submitText:   { type: String,  default: 'Salvar' },
    cancelText:   { type: String,  default: 'Cancelar' },
    isFormValid:  { type: Boolean, default: true },
    isSubmitting: { type: Boolean, default: false },
  },
  methods: {
    onSubmit() {
      if (this.isSubmitting) {
        console.warn("BaseForm: submissão ignorada, já está enviando.");
        return;
      }
      this.$emit('submit');
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style>
.small-btn {
  padding: 8px 10px;      /* mantém seu tamanho reduzido */
  font-size: 0.75rem;
  line-height: 1;
}
</style>
